import React from "react";
import "./FinancialProductCarousel.scss";
import { SelectableCardGroup } from "@ucl/library";
import { FinancialProductCard, FinancialProduct } from "./FinancialProductCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

export interface FinancialProductCarouselProps {
  products: FinancialProduct[];
  selectedProducts: string[];
  onProductSelect?: (productIds: string[]) => void;
  multiSelect?: boolean;
}

export const FinancialProductCarousel: React.FC<FinancialProductCarouselProps> = ({
  products,
  selectedProducts,
  onProductSelect,
  multiSelect = false,
}) => {
  const handleProductSelect = (productIds: string | string[]) => {
    const arr = Array.isArray(productIds) ? productIds : [productIds];
    onProductSelect?.(arr);
  };

  const isSelected = (productId: string) => selectedProducts.includes(productId);

  return (
    <div className="financial-product-carousel">
      <div className="financial-product-carousel__container">
        <SelectableCardGroup
          options={products.map((product) => ({
            key: product.id,
            headerContent: (
              <>
                <FontAwesomeIcon icon={!isSelected(product.id) ? faCircle : faCircleCheck} />
                <h4 className="bp5-heading">{product.title}</h4>
              </>
            ),
            cardContent: (
              <FinancialProductCard
                product={product}
                isSelected={isSelected(product.id)}
              />
            ),
          }))}
          value={selectedProducts}
          onChange={handleProductSelect}
          multiSelect={multiSelect}
          cardType="primary"
          color="forest-green"
          className="financial-product-carousel__card-group"
          style={{ height: "100%", gap: "1rem" }}
        />
      </div>
    </div>
  );
};

export default FinancialProductCarousel;
